import * as React from "react";
import { ButtonGroup, Button, makeStyles, createStyles, Theme } from "@material-ui/core";
import Loader from "react-loader-spinner";

const useStyles = makeStyles((theme: Theme) => {
  const labelFontSize = "0.6rem";

  return createStyles({
    root: {
      "position": "relative",

      "& .label": {
        position: "absolute",
        fontSize: labelFontSize,
        top: `calc(-${labelFontSize} - 2px)`,
        whiteSpace: "nowrap",
      },

      "& .spinner": {
        padding: "0px 0px 0px 20px",
      },

      "&  .button-group": {
        "color": theme.customPaper.background.contrast,
        // "background": theme.customPaper.background.cardBackgroundLightContrast,
        "&:hover": {
          "backgroundColor": "inherit",
          "& svg": {
            color: theme.palette.primary.main,
          },
        },
      },

      "& .MuiButton-outlined": {
        padding: theme.spacing(0.25, 2),
      },
    },
  });
});

type ButtonExportProps = {
  label?: string;
  excelVisible?: boolean;
  pdfVisible?: boolean;
  onClickExcel: () => void;
  onClickPdf: () => void;
};

function ButtonExport(props: ButtonExportProps) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = React.useState(false);
  const { label, onClickExcel, onClickPdf, excelVisible = true, pdfVisible = true } = props;

  const handleClickExcel = async () => {
    setIsLoading(true);
    await onClickExcel();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setIsLoading(false);
  };

  const handleClickPdf = async () => {
    setIsLoading(true);
    await onClickPdf();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setIsLoading(false);
  };

  return (
    <div className={classes.root}>
      <span className="label">{label}</span>
      <ButtonGroup>
        {excelVisible && (
          <Button
            disabled={isLoading}
            className={"button-group"}
            onClick={() => handleClickExcel()}
          >
            Excel
          </Button>
        )}
        {pdfVisible && (
          <Button disabled={isLoading} className={"button-group"} onClick={() => handleClickPdf()}>
            PDF
          </Button>
        )}
        {isLoading && (
          <div className="spinner">
            <Loader type="TailSpin" color="#00AB66" height={15} width={15} />
          </div>
        )}
      </ButtonGroup>
    </div>
  );
}

export default ButtonExport;
